import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Spinner from './ui/Spinner';

// roles: lista opcional; sin ella basta con estar autenticado
function ProtectedRoute({ children, roles }) {
  const { usuario, cargando } = useAuth();
  const location = useLocation();

  if (cargando) return <Spinner />;

  const esRutaAdmin = location.pathname.startsWith('/admin');

  if (!usuario) {
    return <Navigate to={esRutaAdmin ? '/admin/login' : '/login'} state={{ desde: location.pathname }} replace />;
  }

  if (roles && !roles.includes(usuario.rol)) {
    // Si ya hay una sesión (ej. de cliente) pero no tiene el rol requerido para /admin,
    // manda a login de staff en vez de a inicio para poder autenticarse con la cuenta correcta.
    return <Navigate to={esRutaAdmin ? '/admin/login' : '/'} replace />;
  }

  return children;
}

export default ProtectedRoute;
